<template>
  <section class="content">
    <div id="overlay"  v-if="loading">
    <div class="spinner"></div>
    <br/>
      <h4>Loading...</h4>
    </div>
      <div class="box box-info">
        <form>
          <div class="p-fluid p-formgrid p-grid p-mt-2">
              <div class="p-field p-col-12 p-md-2">
                <label for="purchaseSalesDate">Challan Date</label>
                  <date-picker ref="tran" v-model="purchaseSalesDate" valueType="format" v-if="!englishDateEnabled"/>
                  <InputMask mask="9999-99-99" ref="tran" type="text" v-else class="nepali-calendar" id="purchaseSalesDate" v-model="purchaseSalesDate"/>
              </div>

              <div class="p-field p-col-12 p-md-2">
                <label for="challanNo" >Challan No</label>
                <InputText id="challanNo"  disabled v-model="challanNo"/>
              </div>
              <div class="p-field p-col-12 p-md-2">
                <label for="referenceNumber">Ref No</label>
                <InputText id="refNO"  v-model="referenceNumber"/>
              </div>
              <div class="p-field p-col-12 p-md-2">
               <label for="warehouse">Store</label>
                <Dropdown
                v-if="!setWarehouseData"
                  v-model="warehouseId"
                  :options="warehouseLists"
                  optionLabel="name"
                  id="warehouse"
                  :filter="true"
                  placeholder="Select warehouse"
                  :showClear="true"
                />
                <Dropdown
                v-if="setWarehouseData"
                  v-model="warehouseId"
                  :options="warehouseLists"
                  optionLabel="name"
                  id="warehouse"
                  :filter="true"
                  placeholder="Select warehouse"
                  :disabled="true"
                />
                <!-- {{warehouseId}} -->
              </div>
              <wearhouseDialog class="p-mt-5" v-tooltip.top="'Add Warehouse'" @set_data_warehouse="set_data_warehouse"/>
            </div>
            <div class="p-fluid p-formgrid p-grid p-mt-2">
              <div class="p-field p-col-12 p-md-4">
               <label for="party">Challan From</label>
                <Dropdown
                  v-model="accountMasterId"
                  :options="supplierAndCustomerList"
                  optionLabel="name"
                  :filter="true"
                  placeholder="Select Vendor"
                  :showClear="true"
                />
              </div>
              <customerDialog style="margin-top:1.3em;margin-right: -10em;" v-tooltip.top="'Add Customer'" @set_customer_master="set_customer_master"/>
              <div class="p-field p-col-12 p-md-2" v-if="!this.editing">
                <label for="loadFrom">Load From Order</label>
                <Dropdown
                  v-model="orderId"
                  :options="orderIdList"
                  optionLabel="orderNo"
                  :filter="true"
                  @change="loadDataWithOrderNo(orderId.orderNo)"
                  placeholder="Select Item"
                />
              </div>
               <div class="p-field p-col-12 p-md-2 p-mt-5" v-if="accountMasterId.id>0" >
                <label for="panNo">Cur. Bal:</label>
                <b  style="color:red" v-if="accountMasterId.closingBalance>0">{{(accountMasterId.closingBalance).toFixed(2)+ 'Cr'}}</b>
                <b  style="color:green;" v-else>{{(accountMasterId.closingBalance *(-1)).toFixed(2) + 'Dr'}}</b>
              </div>
              <!-- <div class="col-md-2 address" v-if="accountMasterId.id>0">
               <label for="address">Contact Name</label>
                <b>{{accountMasterId.contactName}}</b>
              </div> -->
              <div class="p-field p-col-12 p-md-2 p-mt-5" v-if="accountMasterId.id>0" >
                <label for="panNo">Pan No</label>
                <b>{{accountMasterId.panNo}}</b>
              </div>
            </div>
            <div class="p-fluid p-formgrid p-grid p-mt-2">
              <div class="p-field p-col-12 p-md-2">
                <label for="item" >Item<b style="color:red;">*</b></label>
                 <AutoComplete v-model="items" filterMatchMode='contains'
                 :suggestions="filteredItems" @complete="searchItem($event)"
                  field="name" ref="itm">
                 </AutoComplete>
              </div>
              <itemDialog style="margin-top:1.3em;margin-right: -10em;" v-tooltip.top="'Add Item'" @set_data_item="set_data_item"/>
              <div class="p-field p-col-12 p-md-2">
                <label for="quantity">Quantity</label>
                <!-- <input type="text" class="form-control" mode="decimal" :minFractionDigits="2" id="quantity" @keypress="isNumber(event)" v-model="quantity" /> -->
              <InputNumber id="minmaxfraction" v-model="quantity" onfocus="if (this.value === '0.00')
                                this.value = ''" :minFractionDigits="2" :maxFracionDigits="4" />
              </div>
              <div class="p-field p-col-12 p-md-1">
                <label for="qty">Unit</label>
                <InputText v-model="items.unitName" disabled/>
              </div>
              <div class="p-field p-col-12 p-md-2">
                <label  for="rate">Rate</label>
                <!-- <input type="text" class="form-control" id="rate" @keypress="isNumber(event)" v-model="rate" /> -->
              <InputNumber id="minmaxfraction" v-model="rate" onfocus="if (this.value === '0.00')
                                this.value = ''" :minFractionDigits="2" :maxFracionDigits="4" />
              </div>
              <div class="p-field p-col-12 p-md-2">
                <label for="total" >Total</label>
                <!-- <input  class="form-control" id="total" @keypress="isNumber(event)" v-model="total"/> -->
               <InputNumber disabled  id="minmaxfraction" onfocus="if (this.value === '0.00')
                                this.value = ''" v-model="total"  :minFractionDigits="2" :maxFracionDigits="4" />
              </div>

              <div class="p-field p-col-12 p-md-1 p-mt-5">
                <Button class="p-button-raised p-button-rounded" :label="!editDTO?'Add':'Update'"
                @click.prevent="addItemToDTO"/>
                </div>
               <div class="p-field p-col-12 p-md-1 p-mt-5">
                <Button class="p-button-raised p-button-danger" v-if="editDTO"
                @click="itemDTOreset" label="Cancel"/>
              </div>
            </div>
            <div style="display:none;">{{totalAmount}}{{findRate}}{{setRateFromItem}}</div>
            <div class="p-fluid p-formgrid p-grid p-mt-2" v-if="items.id >0">
              <div class="p-field p-col-12 p-md-2">
                <label for="avlQty">Cur. Stock: </label>
                <span>{{items.closingStock}}</span>
              </div>
            </div>
        </form>
        <div class="p-field p-col-12 p-md-12">
          <div class="row">
            <div class="scrollable">
              <table class="table table-bordered ">
                <thead >
                  <tr>
                    <th scope="col">SN</th>
                    <th scope="col">Item Name</th>
                    <th scope="col">Quantity</th>
                    <th scope="col">Rate</th>
                    <th scope="col">Amount</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>
                  <tbody  v-for="(item,index) in inventoryInOutDetailList " :key="index">
                  <tr>
                    <td>{{index+1}}</td>
                    <td>{{item.itemMaster.name}}</td>
                    <td>{{item.quantity}}</td>
                    <td>{{item.rate}}</td>
                    <td>{{item.rate * item.quantity}} </td>
                    <td>
                    <Button  class="p-button-raised p-button-success"
                    @click="editItemFromDTO(item,index)" icon="pi pi-pencil"/>
                    <!-- <Button class="btn btn-danger"  @click="deleteItemFromDTO(item,index)">
                      <i class="fa fa-close (alias)" />
                    </Button> -->
                     <Button class="p-button-raised p-button-danger" v-if="editDTO"
                     @click="deleteItemFromDTO(item, index)" disabled icon="pi pi-trash"/>
                      <Button class="p-button-raised p-button-danger" icon="pi pi-trash"
                      v-else-if="!editDTO" @click="deleteItemFromDTO(item, index)" />
                    </td>
                  </tr>
                </tbody>
              </table>
           </div>
           <hr>
           <div class="p-fluid p-formgrid p-grid p-mt-2">
             <div class="p-field p-col-12 p-md-2">
               <b style="margin-left: 15em;">Total:</b>
             </div>
            <div class="p-field p-col-12 p-md-2">
                <b style="margin-left: 16em;">{{totalQty}}</b>
             </div>
              <div class="p-field p-col-12 p-md-2">
                <b style="margin-left: 38em;">{{subTotal}}</b>
              </div>
             </div>
          <hr>
        </div>
      </div>
      <div class="p-fluid p-formgrid p-grid p-mt-5">
         <div class="p-field p-col-12 p-md-3">
           <label >Narration</label>
            <Textarea rows="5" v-model="narration"/>
          </div>
          <div class="p-field p-col-12 p-md-3"></div>
          <div class="p-field p-col-12 p-md-1">
            <Button class="p-button-raised p-button-secondary" label="print" icon="pi pi-print"/>
          </div>
          <div class="p-field p-col-12 p-md-2">
            <Button class="p-button-raised p-button-secondary" label="Generate PDF" icon="pi pi-download"/>
          </div>
          <div class="p-field p-col-12 p-md-1">
            <Button  class="p-button-raised p-button-warning" @click="reset" v-if="this.salesChallan==undefined" label="Reset" icon="pi pi-refresh"/>
          </div>
          <div class="p-field p-col-12 p-md-1">
            <Button icon="pi pi-save" class="p-button-raised p-button-success" @click.prevent="saveSalesChallan" :label="!editing?'Save':'Update'"/>
          </div>
          <div class="p-field p-col-12 p-md-1">
            <Button  @click.prevent="goBack()" class="p-button-raised p-button-danger" v-if="this.salesChallan!=undefined" label="Cancel"/>
          </div>

        </div>
      </div>
  </section>
</template>
<script>
import Dropdown from 'primevue/dropdown'
import DatePicker from 'vue2-datepicker'
import $ from 'jquery'
import AutoComplete from 'primevue/autocomplete'
import InputNumber from 'primevue/inputnumber'
import InputMask from 'primevue/inputmask'
import customerDialog from '../accountDialog/CustomerAccountDialog'
import wearhouseDialog from '../warehouseDialog/warehouseDialog'
import itemDialog from '../itemDialog/itemMasterDialog'
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
import Textarea from 'primevue/textarea'
export default {
  name: 'salesChallan',
  props: ['salesChallan'],
  data() {
    return {
      warehouseId: '',
      challanNo: null,
      accountMasterId: '',
      items: '',
      referenceNumber: '',
      quantity: 0,
      challanMessage: '',
      rate: 0,
      purchaseSalesDate: null,
      inventoryInOutDetailList: [],
      inventoryInOutDetailDeleteList: [],
      editing: false,
      editDTO: false,
      inventoryHeaderOutId: null,
      index: null,
      loading: false,
      id: null,
      totalQty: '',
      total: 0,
      filteredItems: null,
      englishDateEnabled: true,
      narration: '',
      setWarehouseData: false,
      orderIdList: [],
      orderId: null
    }
  },
  computed: {
    totalBillAmount() {
      return parseFloat(this.quantity) * parseFloat(this.rate)
    },
    // challanNo() {
    //   return this.$store.state.sales.maxSalesChallanNumber
    // },
    // narration() {
    //   if (this.salesChallan === undefined) {
    //     return this.challanMessage + ' ' + this.challanNo
    //   } else {
    //     return this.challanMessage
    //   }
    // },
    totalAmount() {
      if (this.quantity > 0 && this.rate > 0) {
        let totalAmt = 0
        totalAmt = parseFloat(this.quantity) * parseFloat(this.rate).toFixed(2)
        if (isNaN(totalAmt)) {
          totalAmt = 0
        }
        this.total = totalAmt
        return totalAmt
      }
    },
    findRate() {
      let rate = 0
      rate = parseFloat(this.total) / parseFloat(this.quantity).toFixed(2)
      if (isNaN(rate)) {
        rate = 0
      }
      this.rate = rate
      return rate
    },
    setRateFromItem() {
      if (!this.editDTO) {
        let rate = 0
        this.rate = this.items.salesRate
        return rate
      }
    },
    subTotal() {
      let subTotal = 0
      this.taxable = 0
      this.tax = 0
      this.nonTaxable = 0
      this.totalQty = 0
      for (let i = 0; i < this.inventoryInOutDetailList.length; i++) {
        subTotal += (parseFloat(this.inventoryInOutDetailList[i].rate) * parseFloat(this.inventoryInOutDetailList[i].quantity))
        this.itemSelected = this.inventoryInOutDetailList[i].itemMaster
        this.totalQty += parseFloat(this.inventoryInOutDetailList[i].quantity)
      }
      return subTotal
    },
    warehouseLists() {
      return this.$store.state.warehouse.warehouseDropDownList
    },
    supplierAndCustomerList() {
      return this.$store.state.accountMaster.supplierAndCustomerList
    },
    itemMasterListByItemType() {
      return this.$store.state.itemMaster.itemMasterListByItemType
    }
  },
  mounted() {
    this.warehouseList()
    this.supplierCustomerList()
    this.itemMasterListByItemTypes()
    this.maxSalesChallanNo()
    if (this.salesChallan !== undefined) {
      this.editSales()
    }
    this.checkEnglish()
    if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
      this.nepaliDate()
    }
    if (!this.$store.getters.englishDate && this.salesChallan === undefined ||
      this.$store.state.isEnglishDateEnabled === 'false') {
      this.setNepaliDate()
    }
    if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
      this.setEnglishDate()
    }
    this.setWarehouse()
    this.orderIdLists()
  },
  methods: {
    setWarehouse() {
      if (this.$store.state.warehouseData.id > 0) {
        this.setWarehouseData = true
        this.warehouseId = this.$store.state.warehouseData
      } else if (this.warehouseLists.length === 1) {
        this.warehouseId = this.warehouseLists[0]
      }
    },
    async warehouseList() {
      await this.$store.dispatch('loadWarehouseDropDown')
    },
    async supplierCustomerList() {
      await this.$store.dispatch('loadsupplierAndCustomerList')
    },
    async itemMasterListByItemTypes() {
      await this.$store.dispatch('loadFixedAssetsItemMasterList')
    },
    async maxSalesChallanNo() {
      let response = await this.$store.dispatch('fixedAssetsMaxSalesChallanNo')
      if (this.salesChallan === undefined) {
        this.challanMessage = response.data.message
        this.challanNo = response.data.data
        this.narration = response.data.message + '- ' + response.data.data
      } else {
        this.challanNo = this.salesChallan.challanNo
        this.challanMessage = this.salesChallan.remarks
      }
    },
    addItemToDTO() {
      let item = {
        itemId: this.items.id,
        itemMaster: this.items,
        quantity: this.quantity,
        rate: this.rate,
        id: this.id
      }
      if (this.warehouseId === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select store!', life: 10000})
        return
      }
      if (this.accountMasterId === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select sale to!', life: 10000})
        return
      }
      if (this.items.id === undefined) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Invalid item!', life: 10000})
        return
      }
      if (this.items === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select at least one item!', life: 10000})
        return
      } else if (this.quantity <= 0) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Quantity must be greater than 0!', life: 10000})
        return
      } else if (this.rate <= 0) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Rate must be greater than 0!', life: 10000})
        return
      } else {
        if (!this.editDTO) {
          this.inventoryInOutDetailList.push({...item})
        } else {
          this.inventoryInOutDetailList.splice(this.index, 1, {...item})
        }
      }
      this.itemDTOreset()
      this.focusInput()
    },
    editItemFromDTO(data, index) {
      this.itemDTOreset()
      this.editDTO = true
      this.rate = data.rate
      this.quantity = data.quantity
      this.total = (parseFloat(this.rate) * parseFloat(this.quantity)).toFixed(2)
      this.items = data.itemMaster
      this.index = index
      if (data.id !== undefined) {
        this.id = data.id
      }
    },
    async saveSalesChallan() {
      if (this.purchaseSalesDate === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select date!', life: 10000})
        return
      }
      let response = ''
      let salesChallan = {
        challanNo: this.challanNo,
        warehouseId: this.warehouseId.id,
        accountMasterId: this.accountMasterId.id,
        purchaseSalesDate: this.purchaseSalesDate,
        referenceNumber: this.referenceNumber,
        fiscalYearId: this.$store.state.fyId,
        totalBillAmount: this.totalBillAmount,
        remarks: this.narration,
        id: this.inventoryHeaderOutId,
        inventoryInOutDetailList: this.inventoryInOutDetailList,
        inventoryInOutDetailDeleteList: this.inventoryInOutDetailDeleteList
      }
      if (salesChallan.inventoryInOutDetailList.length <= 0) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select at least one item!', life: 10000})
        return
      }
      if (this.salesChallan === undefined) {
        this.loading = true
        response = await this.$store.dispatch('addFixedAssetsSalesChallan', salesChallan)
        this.loading = false
      } else {
        this.loading = true
        response = await this.$store.dispatch('updateFixedAssetsSalesChallan', salesChallan)
        this.loading = false
        this.$router.back()
      }
      if (response.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 10000})
        await this.maxSalesChallanNo()
        this.focusAfterSave()
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: response.data.message, life: 10000})
      }
      this.reset()
    },
    set_data_warehouse(data) {
      this.warehouseId = data
      this.warehouseList()
    },
    set_data_item(data) {
      this.itemMasterListByItemTypes()
      this.items = data
    },
    set_customer_master(data) {
      this.accountMasterId = data
      this.supplierCustomerList()
    },
    editSales() {
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.purchaseSalesDate = this.salesChallan.purchaseSalesDateNepali
      } else {
        this.purchaseSalesDate = this.salesChallan.purchaseSalesDate
      }
      this.referenceNumber = this.salesChallan.referenceNumber
      this.narration = this.salesChallan.remarks
      this.editing = true
      this.inventoryInOutDetailList = this.salesChallan.inventoryInOutDetailList
      this.warehouseId = this.salesChallan.warehouse
      this.accountMasterId = this.salesChallan.accountMaster
      this.inventoryHeaderOutId = this.salesChallan.id
    },
    deleteItemFromDTO(data, id) {
      if (this.editing && data.id !== null) {
        this.inventoryInOutDetailDeleteList.push({...data})
      }
      this.inventoryInOutDetailList.splice(id, 1)
    },
    itemDTOreset() {
      this.items = ''
      this.rate = 0
      this.quantity = 0
      this.total = 0
      this.editDTO = false
      this.id = null
    },
    reset() {
      this.itemDTOreset()
      this.warehouseId = ''
      this.accountMasterId = ''
      this.referenceNumber = ''
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.setNepaliDate()
      } else {
        this.purchaseSalesDate = new Date().toISOString().slice(0, 10)
      }
      this.inventoryInOutDetailList = []
      this.orderId = null
    },
    isNumber(evt) {
      evt = window.event
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    setNepaliDate() {
      if (this.salesChallan === undefined) {
        this.purchaseSalesDate = this.$store.getters.nepaliNewDate
      }
    },
    nepaliDate() {
      $('#purchaseSalesDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.purchaseSalesDate = $('#purchaseSalesDate').val()
        }
      })
    },
    setEnglishDate() {
      this.purchaseSalesDate = new Date().toISOString().slice(0, 10)
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    },
    searchItem(event) {
      setTimeout(() => {
        if (!event.query.trim().length) {
          this.filteredItems = [...this.itemMasterListByItemType]
        } else {
          this.filteredItems = this.itemMasterListByItemType.filter((item) => {
            return item.name.toLowerCase().startsWith(event.query.toLowerCase())
          })
        }
      }, 250)
    },
    focusInput() {
      this.$refs.itm.focus()
    },
    focusAfterSave() {
      this.$refs.tran.focus()
    },
    goBack() {
      if (this.inventoryInOutDetailDeleteList.length > 0) {
        this.salesChallan.inventoryInOutDetailList = this.inventoryInOutDetailDeleteList
      }
      this.$router.back()
    },
    async orderIdLists() {
      let orders = await this.$store.dispatch('loadFixedAssetsSalesOrderIdList')
      if (orders.data.status === 'SUCCESS') {
        this.orderIdList = orders.data.data
      }
    },
    async loadDataWithOrderNo(order) {
      let response = await this.$store.dispatch('loadDataWithFixedAssetsSalesOrderId', order)
      let responseValue = response.data.data
      if (responseValue.length > 0) {
        responseValue.forEach(data => {
          if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
            this.purchaseSalesDate = data.purchaseSalesDateNepali
          } else {
            this.purchaseSalesDate = data.purchaseDate
          }
          // this.inventoryHeaderId = response.id
          // this.narration = data.remarks
          this.referenceNumber = data.referenceNumber
          this.warehouseId = data.warehouse
          this.accountMasterId = data.accountMaster
          this.inventoryInOutDetailList = data.inventoryInOutDetailList
        })
      }
    }
  },
  components: {
    Dropdown,
    DatePicker,
    AutoComplete,
    InputNumber,
    InputMask,
    customerDialog,
    wearhouseDialog,
    itemDialog,
    InputText,
    Button,
    Textarea
  }
}
</script>
<style scoped src="@../../../static/css/purchase.css">

</style>



// WEBPACK FOOTER //
// fixedAssetsSalesChallan.vue?ff3bd44c